/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { OnboardingFlow } from "./OnboardingFlow";
export const OnboardingProgressUpdate = core.serialization.object({
    flow: OnboardingFlow.optional(),
    currentStep: core.serialization.number(),
    completedAt: core.serialization.date().optional(),
});
